module.exports = __webpack_public_path__ + "assets/ca7590b84d258a3a5e39308187359ea0.mp4";